import EmailEditor from "react-email-editor";
import { ContainerStyled } from "./styles/EditorTiny";
import { memo, useCallback } from "react";

const EditorEmail = ({
  editorReady = () => {},
  designUpdate,
  mergeTags = {},
  design = {},
  setExportData,
  editorRef,
  ...props
}) => {
  const onReady = useCallback(() => {
    if (editorRef?.current?.editor) {
      editorRef.current.editor.setMergeTags(mergeTags);
      editorRef.current.editor.loadDesign(design);

      editorRef.current.editor.addEventListener("editor:ready", editorReady);

      editorRef.current.editor.addEventListener("design:updated", () => {
        if (designUpdate) {
          designUpdate();
        } else {
          editorRef.current.editor.exportHtml((data) => setExportData(data));
        }
      });

      if (setExportData) {
        editorRef.current.editor.exportHtml((data) => setExportData(data));
      }
    }
  }, [editorRef, mergeTags, design, editorReady, setExportData, designUpdate]);

  return (
    <>
      <ContainerStyled>
        <EmailEditor
          {...props}
          ref={editorRef}
          onReady={onReady}
          locale="pt-BR"
          minHeight="700px"
        />
      </ContainerStyled>
    </>
  );
};

export default memo(EditorEmail);
